//
//
//
//
//
//

import chartEffects from '~/plugins/mixins/chart-effects';
export default {
  mixins: [chartEffects],
  props: {
    reports: {
      type: Array,
      required: true,
    },
  },
  computed: {
    data() {
      return {
        labels: this.reports.map(r => this.$dateFns.format(r.date || r.created_at, 'MMMM yyyy')),
        datasets: [
          {
            label: 'Ingezaaide eenjarigen',
            data: this.reports.map(r => r.species_present.sown_eenjarigen_species.total),
            backgroundColor: 'rgba(245, 76, 62, 0.3)',
            borderColor: 'rgba(245, 76, 62, 1)',
            borderWidth: 2,
            yAxisID: 'amount',
          },
          {
            label: 'Totaal eenjarigen',
            data: this.reports.map(r => r.species_present.eenjarigen_species.total),
            backgroundColor: 'rgba(245, 76, 62, 0.3)',
            borderColor: 'rgba(245, 76, 62, 1)',
            borderWidth: 2,
            yAxisID: 'amount',
          },
          {
            label: 'Ingezaaide tweejarigen',
            data: this.reports.map(r => r.species_present.sown_tweejarigen_species.total),
            backgroundColor: 'rgba(248, 145, 49, 0.3)',
            borderColor: 'rgba(248, 145, 49, 1)',
            borderWidth: 2,
            yAxisID: 'amount',
          },
          {
            label: 'Totaal tweejarigen',
            data: this.reports.map(r => r.species_present.tweejarigen_species.total),
            backgroundColor: 'rgba(248, 145, 49, 0.3)',
            borderColor: 'rgba(248, 145, 49, 1)',
            borderWidth: 2,
            yAxisID: 'amount',
          },
          {
            label: 'Ingezaaide overblijvende',
            data: this.reports.map(r => r.species_present.sown_meerjarigen_species.total),
            backgroundColor: 'rgba(243, 180, 63, 0.3)',
            borderColor: 'rgba(243, 180, 63, 1)',
            borderWidth: 2,
            yAxisID: 'amount',
          },
          {
            label: 'Totaal overblijvende',
            data: this.reports.map(r => r.species_present.meerjarigen_species.total),
            backgroundColor: 'rgba(243, 180, 63, 0.3)',
            borderColor: 'rgba(243, 180, 63, 1)',
            borderWidth: 2,
            yAxisID: 'amount',
          },
          {
            label: '% kruiden',
            data: this.reports.map(r => r.herbs_to_grass_percentage),
            backgroundColor: 'rgba(181, 199, 66, 0.3)',
            borderColor: 'rgba(181, 199, 66, 1)',
            borderWidth: 2,
            yAxisID: 'percentage',
          },
        ],
      };
    },
    options() {
      return {
        responsive: true,
        legend: {
          display: true,
          onHover: this.onHover,
          onLeave: this.onLeave,
        },
        title: {
          display: true,
          text: 'Aantal soorten',
          fontSize: 24,
          fontColor: '#6b7280',
        },
        scales: {
          yAxes: [
            {
              id: 'amount',
              scaleLabel: {
                display: true,
                labelString: 'Aantal soorten',
              },
            },
            {
              id: 'percentage',
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'Percentage',
              },
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      };
    },
  },
};
